// this.$store.state.ticket
import { db } from "@/firebase";
import {
  doc,
  getDoc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";

// TICKETS DE SOPORTE TÉCNICO
export const ticket = {
  objeto: class {
    constructor() {
      return {
        id: "",
        codigo: "",
        idUsuario: "",
        idEmpresa: "",
        solicitante: {
          nombre: "",
          correo: "",
          telefono: "",
        },
        tipo: "",
        modulo: "",
        descripcion: "",
        estado: "Pendiente",
        aceptoTerminos: false,
        comentarios: [],
        registro: {
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
          estado: "Creado",
        },
      };
    }
  },
  funciones: {
    async crear(ticket) {
      await setDoc(doc(db, "riskmann_tickets", ticket.id), ticket);
    },
    async actualizarEstado(id, estado) {
      await updateDoc(doc(db, "riskmann_tickets", id), {
        estado,
        "registro.actualizacion": serverTimestamp(),
      });
    },
    async agregarComentario(id, comentario) {
      await updateDoc(doc(db, "riskmann_tickets", id), {
        comentarios: arrayUnion(comentario),
        "registro.actualizacion": serverTimestamp(),
      });
    },
    async obtener(id) {
      const snap = await getDoc(doc(db, "riskmann_tickets", id));
      return snap.exists() ? snap.data() : null;
    },
    async generarID() {
      const ref = doc(collection(db, "riskmann_tickets"));
      return ref.id;
    },
    async generarCodigo() {
      const anio = new Date().getFullYear();
      const q = query(
        collection(db, "riskmann_tickets"),
        where("codigo", ">=", `TKT-${anio}-`),
        where("codigo", "<", `TKT-${anio + 1}-`),
      );
      const snap = await getDocs(q);
      const numero = String(snap.size + 1).padStart(5, "0");
      return `TKT-${anio}-${numero}`;
    },
  },
};
